import { Pagination, Spin, Table as BaseTable } from 'antd';

import type { ModelNeuralNetworkLogsResult } from '@app/api/NeuralNetworkLogs';

import { PF } from '@pages/NeuralNetworkLogs/data';
import type { TableNeuralNetworkLogsType } from '@pages/NeuralNetworkLogs/types';

const TABLE = `${PF}_table`;

export const Table: TableNeuralNetworkLogsType = ({
  isPageLoading,
  data,
  isFetching,
  onPaginate,
  pagination: { itemsPerPage, page, total },
  columns,
}) => {
  if (isPageLoading) {
    return (
      <div className={`${TABLE}_loading`}>
        <Spin spinning />
      </div>
    );
  }

  return (
    <div className={`${TABLE}_container`}>
      <BaseTable<ModelNeuralNetworkLogsResult>
        columns={columns}
        dataSource={data}
        rowKey={({ Id }) => Id}
        pagination={false}
        size="middle"
        loading={isFetching}
        className={TABLE}
      />

      {total > 0 && (
        <div className={`${TABLE}_pagination`}>
          <div className={`${TABLE}_pagination_left`}>
            <Pagination
              current={page}
              total={total}
              pageSize={itemsPerPage}
              onChange={onPaginate}
              showTotal={(total, range) => (
                <span data-testid="pagination-info">{`Показаны ${range[0]}-${range[1]} из ${total}`}</span>
              )}
            />
          </div>
        </div>
      )}
    </div>
  );
};
